// src/app/modules/apps/call/wallboard/ServiceLevelInbound.tsx
import React from 'react';

interface Props {
  value: number;
  label: string;
  color: string;
  size?: number;
  strokeWidth?: number;
  isDark?: boolean;  
}

const ServiceLevelInbound: React.FC<Props> = ({
  value,
  label,
  color,
  size = 120,
  strokeWidth = 12,
  isDark = false  
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (Math.min(value, 100) / 100) * circumference;

  return (
    <div className="service-level-gauge" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="gauge-svg">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size/2} ${size/2})`}
          className="gauge-progress"
        />
        <text
          x={size / 2}
          y={size / 2 + 9}
          dy="-5"
          textAnchor="middle"
          dominantBaseline="middle"
          className="gauge-value"
          fill={isDark ? '#f1f5f9' : '#1e293b'}
          fontSize="20"
          fontWeight="700"
        >
          {Math.round(value)}%
        </text>
        <text
          x={size / 2}
          y={size / 2 + 18}
          textAnchor="middle"
          className="gauge-label"
          fill={isDark ? '#94a3b8' : '#64748b'}
          fontSize="9"
        >
          {label}
        </text>
      </svg>
    </div>
  );
};

export default ServiceLevelInbound;